import * as Yup from "yup";
import { keywordRules } from "./rules/KeywordsRules";

const DiagnosisAnalysisSchema = Yup.object().shape({
  keyword: keywordRules.required("validator:global.required")
});

export default DiagnosisAnalysisSchema;